import React, { useCallback } from 'react';
import { int32 } from 'appConstants';
import FormInput from 'components/Input/FormInput';

interface ILaunchCountField {
	changeLaunchCount: (value: string) => void;
}

const LaunchCountField: React.FC<ILaunchCountField> = ({ changeLaunchCount }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			let onlyDigits = e.target.value.replace(/\D/g, '');
			Number(onlyDigits) > int32 && (onlyDigits = String(int32));
			changeLaunchCount(onlyDigits);
			return onlyDigits;
		},
		[changeLaunchCount],
	);

	return (
		<FormInput
			testId="LaunchCountField"
			name="launchCount"
			label="launchCountLabel"
			getValueFromEvent={handleChange}
		/>
	);
};

export default React.memo(LaunchCountField);
